import { useEffect, useState } from "react";
import { Menu as MenuIcon, Phone, X } from "lucide-react";
import { Wave } from "./Wave";
import { getOpenStatus } from "../lib/hours";
import business from "../data/business.json";

const NAV = [
    { href: "#locale", label: "Il locale" },
    { href: "#serate", label: "Serate" },
    { href: "#menu", label: "Menu" },
    { href: "#recensioni", label: "Recensioni" },
    { href: "#galleria", label: "Galleria" },
    { href: "#dove-siamo", label: "Dove siamo" },
];

export const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState(() => getOpenStatus());

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        const t = setInterval(() => setStatus(getOpenStatus()), 60000);
        return () => {
            window.removeEventListener("scroll", onScroll);
            clearInterval(t);
        };
    }, []);

    return (
        <header
            className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
                scrolled || open ? "bg-carbone/95 backdrop-blur border-b border-bordo" : "border-b border-transparent"
            }`}
        >
            <div className="container-pub flex items-center justify-between h-[72px] gap-4">
                <a href="#top" className="flex items-center gap-3 leading-none" data-testid="header-logo">
                    <img
                        src="/images/logo-river-pub.png"
                        alt="Logo River Pub"
                        width={44}
                        height={44}
                        className="h-11 w-11 rounded-full ring-1 ring-bordo"
                    />
                    <span className="flex flex-col items-start leading-none whitespace-nowrap">
                        <span className="font-heading font-semibold uppercase text-xl tracking-[0.22em] text-avorio">
                            River Pub
                        </span>
                        <Wave className="w-12 h-2.5 mt-1 text-ambra" />
                    </span>
                </a>
                <nav className="hidden lg:flex items-center gap-6" aria-label="Navigazione principale">
                    {NAV.map((n) => (
                        <a
                            key={n.href}
                            href={n.href}
                            className="text-sm text-avorio/80 hover:text-ambra transition-colors"
                            data-testid={`nav-${n.href.slice(1)}`}
                        >
                            {n.label}
                        </a>
                    ))}
                </nav>
                <div className="flex items-center gap-3">
                    <div className="hidden md:block">
                        <span
                            className={`inline-flex items-center gap-2 chip !min-h-0 !py-1.5 ${
                                status.open ? "!border-prato" : ""
                            }`}
                            data-testid="open-status-badge"
                        >
                            <span
                                className={`w-2 h-2 rounded-full ${status.open ? "bg-prato" : "bg-ambra"}`}
                                aria-hidden="true"
                            />
                            <span className="tabular text-[13px]">{status.label}</span>
                        </span>
                    </div>
                    <a
                        href={business.phone.href}
                        className="btn btn-amber !px-4"
                        data-testid="header-phone-btn"
                        aria-label={`Chiama il ${business.phone.display}`}
                    >
                        <Phone className="w-[18px] h-[18px]" />
                        <span className="hidden lg:inline tabular">{business.phone.display}</span>
                    </a>
                    <button
                        className="lg:hidden btn btn-outline !px-3"
                        onClick={() => setOpen(!open)}
                        aria-expanded={open}
                        aria-controls="mobile-nav"
                        aria-label={open ? "Chiudi menu" : "Apri menu"}
                        data-testid="header-menu-btn"
                    >
                        {open ? <X className="w-5 h-5" /> : <MenuIcon className="w-5 h-5" />}
                    </button>
                </div>
            </div>
            {open && (
                <div id="mobile-nav" className="lg:hidden bg-carbone border-b border-bordo">
                    <nav className="container-pub py-4 flex flex-col" aria-label="Navigazione mobile">
                        {NAV.map((n) => (
                            <a
                                key={n.href}
                                href={n.href}
                                onClick={() => setOpen(false)}
                                className="py-3 font-heading uppercase tracking-wide text-lg text-avorio hover:text-ambra border-b border-bordo/50 last:border-0"
                                data-testid={`mobile-nav-${n.href.slice(1)}`}
                            >
                                {n.label}
                            </a>
                        ))}
                        <span className="chip mt-4 self-start" data-testid="open-status-badge-mobile">
                            <span
                                className={`w-2 h-2 rounded-full ${status.open ? "bg-prato" : "bg-ambra"}`}
                                aria-hidden="true"
                            />
                            <span className="tabular text-[13px]">{status.label}</span>
                        </span>
                    </nav>
                </div>
            )}
        </header>
    );
};